import * as d3 from "d3";
import {colonAnnotation, numberFormat} from '../functions'

export default function (chart, divId, vizName, resData) {
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData;
        console.log("data is:", data)

        // var width = 2700;
        // var height = 230;

        var categories = d3.nest()
            .key(function (d) {
                return d.dim1_name;
            })
            //  .key(function(d) { return d.dim2_name; }).sortKeys(d3.ascending)
            .entries(data);

        console.log("cat", categories)
        var color = d3.scaleOrdinal()
            .domain(categories[0].values.map(function (d) {
                return d.dim2_name;
            }).sort(d3.ascending))
            .range(["blue", "red", "orange"])


        console.log("datampainn", categories[0].values.map(function (d) {
            return d.dim2_name;
        }).sort(d3.ascending));

        var svg = d3.select(divId).select("svg").remove();

        // Make SVG container
        svg = d3
            .select(divId)
            //   .classed("svg-container", true)
            .append("svg")
            .attr('width', chart.width + chart.margin.right - chart.margin.left)
            .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        // .call(responsivefy)


        var elem = svg
            .selectAll("svg")
            .data(data);

        var elemEnter = elem
            .enter()
            .append("g")
            .attr("transform", "translate(100, 0)"); // prevent svg crops first circle


        var circles = elemEnter
            .append("circle")
            .attr("cx", function (d, i) {
                return 40 + 120 * i
            })
            .attr("cy", 160)
            // .attr("r",function(d) { return rscale(d.metric1)*20})
            .attr("r", 50)
            .style("fill", "white")
            .style("stroke-width", "8px")
            .style("stroke", function (d) {
                return color(d.dim2_name)
            });


        console.log(circles)
        elemEnter
            .append("text")
            .text(function (d) {
                return numberFormat(d.metric1)
            })
            .style('text-anchor', 'middle')
            .style("fill", "black")
            .attr("dy", 165)
            .attr("dx", function (d, i) {
                return d.metric1.toString().length >= 5 ? 40 + 120 * i : 50 + 120 * i
            })
            .style("font-size", "15px")
            .style("font-weight", "bold")


        elemEnter
            .append("text")
            .style("fill", "black")
            .attr("dy", function (d, i) {
                return 100 + 100 * i
            })
            .attr("dx", function (d, i) {
                return -65 + 60 * i
            })
            // .attr("dy", 85)
            // .attr("dx",  function(d,i){ return 45 -120 *i
            // })
            .text(function (d) {
                return d.dim1_name
            })
            .style("text-anchor", "start")
            .style("font-weight", "bold")
            .style("font-size", "15px")
            .attr('transform', 'rotate(-60)');

        var rscale = d3.scaleSqrt()
            .domain([d3.min(data, function (d) {
                return d.metric1
            }), d3.max(data, function (d) {
                return d.metric1
            })])
            .range([11, 50])

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId).append('div').attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;')

        var elem2 = svg
            .selectAll("svg")
            .data(data);

        var elemEnter2 = elem2
            .enter()
            .append("g")
            .attr("transform", "translate(100, 150)"); // prevent svg crops first circle


        var circles2 = elemEnter2
            .append("circle")
            .attr("cx", function (d, i) {
                return 40 + 120 * i
            })
            .attr("cy", 160)
            // .attr("r",function(d) { return rscale(d.metric1)*20})
            .attr("r", function (d) {
                return rscale(d.metric1)
            })
            //   .style("fill","white")
            .style("fill", function (d) {
                return color(d.dim2_name)
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.dim2_name + "(" + d.dim1_name + ")" + colonAnnotation + d.metric1)

                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            })


        console.log(circles2)

        var legend = svg.append('g')
            .attr("class", "legend")
            .selectAll("g")
            .data(color.domain())
            //setting the data as we know there are only two set of data[programmar/tester] as per the nest function you have written
            .enter().append("g")
            .attr("transform", function (d, i) {
                return "translate(0," + i * 40 + ")";
            });

        legend.append("rect")
            .attr('x', 2400)
            .attr('y', 70)
            .attr("width", 25)
            .attr("height", 25)
            .style("fill", color);

        legend.append("text")
            .attr("x", 2440)
            .attr("y", 80)
            .attr("dy", ".35em")
            .style("font-size", "30px")
            .text(function (d) {
                return d
            });
    // })
}
